// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common.conf with an alias.
import Vue from 'vue'
import App from './App'
import {getParamsFromUrl, makeUrl, setTitle} from "../src/lib/utils";
import VConsole from 'vconsole'
import router from './router'
import install from '../h5/lib/install'
import urlHistory from "../src/lib/urlHistory";
import VueClipboard from 'vue-clipboard2'

if (process.env.NODE_ENV === 'production') {
  // new VConsole()
}
Vue.use(install)
Vue.use(VueClipboard)

// 使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  // Log('to,from', to, from)
  urlHistory.set(to.fullPath)
  let {title} = to.meta
  if (title) {
    setTitle('施尔明眼科医院')
  } else {
    setTitle('施尔明眼科医院')
  }
  next()
})

Vue.config.productionTip = false

let urlParams = getParamsFromUrl(location.href)
let {query} = urlParams

if (!query || !query.version) {
  query = Object.assign({}, query, {version: VERSION})
  location.replace(makeUrl(Object.assign({}, urlParams, {query})))
} else {
  // 通过一个空的vue实例放出一个全局的方法
  window.bus = new Vue()
  new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
  })
}

/* eslint-disable no-new */



// WEBPACK FOOTER //
// ./h5/h5.js